import { useRole } from '@/auth/useRole'
import { PostinvestLayout } from '@/features/postinvest/PostinvestLayout'
import { PreinvestLayout } from '@/features/preinvest/PreinvestLayout'
import { RelatiesLayout } from '@/features/crm/RelatiesLayout'
import { lastModule } from '@/lib/lastModule'

/**
 * The shell of the module you came from, for pages that belong to no module of their own
 * (/beveiliging; spec-64 U-011). The fundraiser only has Relaties; everyone else falls back
 * to pre-invest.
 */
export function LastModuleLayout() {
  const { role } = useRole()
  const module = role === 'fundraiser' ? 'relaties' : (lastModule() ?? 'preinvest')
  if (module === 'postinvest') return <PostinvestLayout />
  if (module === 'relaties') return <RelatiesLayout />
  return <PreinvestLayout />
}
